<template>
  <div id="Zestawienie">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false" id="dialogZestawienie">

      <div v-if="loading">
        <app-loader />
      </div>

      <div id="nav" style="width:100%; padding:5px; background: rgba(100,100,100,0.2);height: 70px;width: 100%">

        <div style="width: auto;
          float: left;
          background: white;
          border: 1px solid red;
          border-radius: 5px;">
          <button class="btn" @click="generateReport()" style="background: no-repeat; border: 1px solid #C1C1C1;"><img src="../../assets/img/pdf2.svg" width="34"/></button>
        </div>
        <div style="width: 50%; float: right;">
          <button
          class="btn btn-default"
          style="float: right; margin: 5px 34px; color:#007bff;background:#fff;border:1px solid #007bff"
          @click="closeDialog(0)">{{$t('message.zamknij')}}</button>
        </div>
      </div>

      <vue-html2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="false"
          :paginate-elements-by-height="1400"
          :filename="file_name"
          :pdf-quality="2"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="840px"
          @progress="onProgress($event)"
          @beforeDownload="beforeDownload($event)"
          @hasDownloaded="hasDownloaded($event)"
          ref="html2Pdf"
      >

        <section slot="pdf-content">
          <section class="pdf-item">
            <div id="naglowek">

              <div style="text-align: center; width: 105px;">
                CONFI-RACK
                <div style="width: 100px; text-align: center; font-size: 12px; line-height:12px">
                  {{$t('message.wydruk')}}<br><span style="font-weight:bold">{{ new Date().toLocaleDateString() }}</span></div>
              </div>
              <div style="position: relative;width: 518px;margin: 0px auto;">
                <div>
                  <md-dialog-title>{{$t('message.widok_szafy')}}</md-dialog-title>
                  <!-- <hr class="new"> -->
                </div>
              </div>

              <div class="col" id="logo_pulsar" v-if="target === 'localhost'"><img src="../../assets/logo_dark.png"/></div>
              <div v-else id="logo" :style="{ 'backgroundImage': 'url(\'' + urlImage + '\')' }"></div>

            </div>
            <SzafaDruk/>
          </section>
          <div class="html2pdf__page-break"/>

          <section class="pdf-item">
            <div id="naglowek">
              <div style="text-align: center; width: 105px;">
                CONFI-RACK
                <div style="width: 100px; text-align: center; font-size: 12px; line-height:12px">
                  {{$t('message.wydruk')}}<br><span style="font-weight:bold">{{ new Date().toLocaleDateString() }}</span></div>
              </div>
              <div style="position: relative;width: 518px;margin: 0px auto;">
                <div>
                  <md-dialog-title>{{$t('message.zestawienie_cenowe')}}</md-dialog-title>
                  <!-- <hr class="new"> -->
                  <p v-if="$i18n.locale === 'pl'" style="font-size: 16px; text-align: center; margin: 5px 0px; font-weight: bold;">
                    {{$t('message.cena_detal')}}</p>
                </div>
              </div>

              <div class="col" id="logo_pulsar" v-if="target === 'localhost'"><img src="../../assets/logo_dark.png"/></div>
              <div v-else id="logo" :style="{ 'backgroundImage': 'url(\'' + urlImage + '\')' }"></div>

            </div>

            <br>
            <h5>{{$t('message.lista_produktow')}}</h5>
            <table class="table" v-if="Object.keys(outputs.szafa).length>0">
              <thead>
                <tr style="background: rgb(221, 221, 221) none repeat scroll 0% 0%;">
                  <th class='c1' scope="col">{{$t('message.kod')}}</th>
                  <th class='c2' scope="col">{{$t('message.nazwa')}}</th>
                  <th class='c3' scope="col">{{$t('message.ilosc')}}</th>
                  <th class='c4' scope="col">{{$t('message.waga')}}<br>1{{$t('message.szt')}} [{{$t('message.kg')}}]</th>
                  <th class='c5' scope="col" v-if="$i18n.locale === 'pl'">{{$t('message.cena_detal')}}<br>1{{$t('message.szt')}} [{{$t('message.zl')}}]</th>
                  <th class='c6' scope="col" v-if="$i18n.locale === 'pl'">{{$t('message.wartosc_netto')}} [{{$t('message.zl')}}]</th>
                  <th class='c7' scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">{{$t('message.rabat')}}</th>
                  <th class='c8' scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">{{$t('message.netto_po_rabacie')}}</th>
                </tr>
              </thead>
              <tbody>
 <!-- v-if="$i18n.locale === 'pl'" -->
                <template v-if="!inputs.sameAkcesoria">
                <tr>
                    <td>{{outputs.szafa.symbol}}</td>
                    <td>{{outputs.szafa.nazwa}}</td>
                    <td>1</td>
                    <td>{{Number(outputs.szafa.waga)}}</td>
                    <td v-if="$i18n.locale === 'pl'">{{Number(outputs.szafa.cena)}}</td>
                    <td v-if="$i18n.locale === 'pl'">{{Number(outputs.szafa.cena)}}</td>
                    <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">{{inputs.rabatValue}}%</td>
                    <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">{{oblicz_procent(1, Number(outputs.szafa.cena))}}</td>
                  </tr>
                </template>
                <tr v-for="(produktPrzod, indexPrzod) in produktyPrzod" :key='"przod" + indexPrzod'>
                  <td>{{produktPrzod.symbol}}</td>
                  <td>{{produktPrzod.nazwa}}</td>
                  <td>{{Number(produktPrzod.value)}}</td>
                  <td>{{Number(produktPrzod.waga)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(produktPrzod.cena)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(produktPrzod.total)}}</td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktPrzod.wyprzedaz || produktPrzod.promocja) ? '0' : inputs.rabatValue}}%
                  </td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktPrzod.wyprzedaz || produktPrzod.promocja) ? Number(produktPrzod.total) : oblicz_procent(produktPrzod.value, Number(produktPrzod.cena))}}
                  </td>
                </tr>
                <tr v-for="(produktTyl, indexTyl) in produktyTyl" :key='"tyl" + indexTyl'>
                  <td>{{produktTyl.symbol}}</td>
                  <td>{{produktTyl.nazwa}}</td>
                  <td>{{Number(produktTyl.value)}}</td>
                  <td>{{Number(produktTyl.waga)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(produktTyl.cena)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(produktTyl.total)}}</td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktTyl.wyprzedaz || produktTyl.promocja) ? '0' : inputs.rabatValue}}%
                  </td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktTyl.wyprzedaz || produktTyl.promocja) ? Number(produktTyl.total) : oblicz_procent(produktTyl.value, Number(produktTyl.cena))}}
                  </td>
                </tr>
                <tr v-for="(produktInne, indexInne) in produktyInne" :key='"inne" + indexInne'>
                  <td>{{produktInne.symbol}}</td>
                  <td>{{produktInne.nazwa}}</td>
                  <td>{{Number(produktInne.value)}}</td>
                  <td>{{Number(produktInne.waga)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(produktInne.cena)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(produktInne.total)}}</td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktInne.wyprzedaz || produktInne.promocja) ? '0' : inputs.rabatValue}}%
                  </td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktInne.wyprzedaz || produktInne.promocja) ? Number(produktInne.total) : oblicz_procent(produktInne.value, Number(produktInne.cena))}}
                  </td>
                </tr>
                <tr v-for="(produktArad, indexArad) in produktyArad" :key='"arad" + indexArad'>
                  <td>{{produktArad.symbol}}</td>
                  <td>{{produktArad.nazwa}}</td>
                  <td>{{produktArad.value}}</td>
                  <td>{{Number(produktArad.waga)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{Number(produktArad.cena)}}</td>
                  <td v-if="$i18n.locale === 'pl'">{{produktArad.total}}</td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktArad.wyprzedaz || produktArad.promocja) ? '0' : inputs.rabatValue}}%
                  </td>
                  <td scope="col" v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                    {{(produktArad.wyprzedaz || produktArad.promocja) ? Number(produktArad.total) : oblicz_procent(produktArad.value, Number(produktArad.cena))}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table id="tableResults" style="float: right;
margin: 15px 50px;
width: 250px;
background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
min-height: 65px;">
              <tr>
                <td>{{$t('message.waga')}}:</td>
                <td><b>{{Number(results.waga).toFixed(2)}} {{$t('message.kg')}}</b></td>
              </tr>
              <tr>
                <td>{{$t('message.wartosc_netto')}}:</td>
                <td><b>{{Number(results.cena) + Number(results.wyprzedaz)}} {{$t('message.zl')}}</b></td>
              </tr>
              <tr v-if="$i18n.locale === 'pl' && inputs.rabatValue > 0">
                <td>{{$t('message.netto_po_rabacie')}}:</td>
                <td><b>{{oblicz_procent(1, Number(results.cena)) + Number(results.wyprzedaz)}} {{$t('message.zl')}}</b></td>
              </tr>
            </table>

            <!-- <div style="text-align: right;">
              <div v-if="$i18n.locale === 'pl'" style="width: 265px;text-align: center;float: right;">{{$t('message.wartosc_netto')}}: <b>{{Number(results.cena)}} {{$t('message.zl')}}</b></div>
              <div style="width: 265px;text-align: center;float: right;">{{$t('message.waga')}}: <b>{{Number(results.waga).toFixed(2)}} {{$t('message.kg')}}</b></div>
            </div>
            <div style="text-align: right;">
              <div v-if="$i18n.locale === 'pl'" style="width: 265px;text-align: center;float: right;">{{$t('message.netto_po_rabacie')}}: <b>{{Number(results.cena)}} {{$t('message.zl')}}</b></div>
            </div> -->
          </section>
          <div class="html2pdf__page-break"/>

        </section>
      </vue-html2pdf>

    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../../mixins/app'

import VueHtml2pdf from 'vue-html2pdf'
import SzafaDruk from '../View/SzafaDruk'
// import WizualizacjaStacji from '../WizualizacjaStacji'

export default {
  name: 'Zestawienie',
  props: ['showDialog'],
  mixins: [app],
  data () {
    return {
      page: 'dane',
      file_name: 'confi-rack-' + new Date().toLocaleDateString(),
      exporting: false,
      parentUrl: ''
    }
  },
  components: {
    VueHtml2pdf, SzafaDruk
    // Wizualizacja, , WizualizacjaStacji
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    target () {
      return process.env.VUE_APP_TARGET
    },
    urlImage () {
      // var server = window.location.origin
      // var currentUrl = window.location.pathname
      // return server + currentUrl + 'img/logo.png'
      return (this.parentUrl !== null && this.parentUrl !== undefined) ? this.parentUrl + 'img/logo_dark.png' : 'img/logo_dark.png'
    },
    produktyArad () {
      var newArray = []
      this.outputs.podzespoly.forEach(element => {
        if (element !== null) {
          Object.values(element).forEach(item => {
            if (Number(item.value) > 0) {
              const found = newArray.find(element => element.symbol === item.symbol)
              if (found) {
                found.value = Number(found.value) + Number(item.value)
                found.total = Number(found.value) * Number(item.cena)
              } else {
                item.total = Number(item.value) * Number(item.cena)
                newArray.push(JSON.parse(JSON.stringify(item)))
              }
            }
          })
        }
      })
      return newArray
    },
    produktyPrzod () {
      var newArray = []
      var tempItems = JSON.parse(JSON.stringify(this.outputs.items_przod))
      tempItems.forEach(item => {
        if (!item.type) {
          const found = newArray.find(element => (element.symbol === item.symbol))
          if (found) {
            found.value = Number(found.value) + Number(item.value)
            found.total = Number(found.value) * Number(item.cena)
          } else {
            item.value = 1
            item.total = Number(item.value) * Number(item.cena)
            newArray.push(JSON.parse(JSON.stringify(item)))
          }
        }
      })
      return newArray
    },
    produktyTyl () {
      var newArray = []
      var tempItems = JSON.parse(JSON.stringify(this.outputs.items_tyl))
      tempItems.forEach(item => {
        const found = newArray.find(element => element.symbol === item.symbol)
        if (found) {
          found.value = Number(found.value) + Number(item.value)
          found.total = Number(found.value) * Number(item.cena)
        } else {
          item.value = 1
          item.total = Number(item.value) * Number(item.cena)
          newArray.push(JSON.parse(JSON.stringify(item)))
        }
      })
      return newArray
    },
    produktyInne () {
      var newArray = []
      var tempItems = JSON.parse(JSON.stringify(this.outputs.items_inne))
      tempItems.forEach(item => {
        item.total = Number(item.value) * Number(item.cena)
        newArray.push(Object.assign([], item))
        // }
      })
      return newArray
    },
    results () {
      var cena = 0
      var waga = 0
      var cenaWyprzedaz = 0

      if (!this.inputs.sameAkcesoria) {
        cena += Number(this.outputs.szafa.cena)
        waga += Number(this.outputs.szafa.waga)
      }
      this.produktyPrzod.forEach(item => {
        if (item.wyprzedaz || item.promocja) {
          cenaWyprzedaz += Number(item.total)
        } else {
          cena += Number(item.total)
        }
        waga += Number(item.waga)
      })
      this.produktyTyl.forEach(item => {
        if (item.wyprzedaz || item.promocja) {
          cenaWyprzedaz += Number(item.total)
        } else {
          cena += Number(item.total)
        }
        waga += Number(item.waga)
      })
      this.produktyInne.forEach(item => {
        if (item.wyprzedaz || item.promocja) {
          cenaWyprzedaz += Number(item.total)
        } else {
          cena += Number(item.total)
        }
        waga += Number(item.waga)
      })
      this.produktyArad.forEach(item => {
        if (item.wyprzedaz || item.promocja) {
          cenaWyprzedaz += Number(item.total)
        } else {
          cena += Number(item.total)
        }
        waga += Number(item.waga)
      })

      return {cena: cena, waga: waga, wyprzedaz: cenaWyprzedaz}
    }
  },
  methods: {
    closeDialog () {
      this.$emit('clickedClose', false)
    },
    setCenaWaga (array, target) {
      if (!this.inputs.sameAkcesoria) {
        this.cenaNetto += Number(this.outputs.szafa.cena)
        this.wagaNetto += Number(this.outputs.szafa.waga)
      }
      if (array.length > 0) {
        array.forEach(element => {
          this.cenaNetto += Number(element.total)
          this.wagaNetto += Number(element.waga) * Number(element.value)
        })
      }
    },
    generateReport () {
      console.log('--- generateReport ---')
      window.dataLayer.push({'event': 'report-click', 'label': 'Generowanie podsumowania do PDF', 'action': 'click', 'value': 1})
      this.$refs.html2Pdf.generatePdf()
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(10)
          pdf.setTextColor(150)
          pdf.text('Strona ' + i + ' z ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
        }
        // this.$store.commit('app/SET_LOADING', false, { root: true })
      }).save()
    },
    onProgress ({ html2pdf, options, pdfContent }) {
      // this.$store.commit('app/SET_LOADING', false, { root: true })
    },
    hasDownloaded ({ html2pdf, options, pdfContent }) {
      console.log('hasDownloaded')
    },
    oblicz_procent (ilosc, cena) {
      var price = (Number(cena) - (Number(cena) * (this.inputs.rabatValue / 100))) * Number(ilosc)
      return Number(price.toFixed(2))
    }
  },
  mounted () {
    let _this = this
    window.addEventListener('message', function (e) {
      _this.parentUrl = e.data.url
    })
    // var url = (window.location !== window.parent.location)
    //   ? document.referrer
    //   : document.location.origin + document.location.pathname
    // this.parentUrl = url
  }
}
</script>

<style scoped>
#Zestawienie {
  font-size: 14px;
}
#Zestawienie table tr {
height: 25px;
}
#dialogZestawienie .md-dialog .md-dialog-container {
    width: 920px !important;
    max-width: 1024px !important;
}
#Wizualizacja {
  transform: scale(0.75);
}
#Stacja {
transform: scale(0.25);
width: 440px;
position: absolute;
bottom: 164px;
left: -225px;
}
#Stacja ul li {
display: inline-block;
margin: 10px 10px;
}
#naglowek {
  width: 94%;
  display: flex;
  height:65px
}
#naglowek ul {
  margin-bottom:0px;
  line-height: 12px;
}
#naglowek ul li {
  display: block;
  margin: 0px;
}
.vue-html2pdf {
  overflow: auto;
  overflow-x: hidden;
}
section.pdf-item {
  margin-bottom: 30px;
  padding: 0px 15px;
}
table {
  width: 94%;
  text-align: left;
font-size: 12px;
}
table tr th {
font-size: 11px;
line-height: 12px;
text-align: center;
border: 1px solid #d1d0d0;
padding: 4px;
}
table tr:nth-child(even) {background: #F7F7F7}
table tr:nth-child(odd) {background: #FFF}

table tr td{
    text-align: center;
    border: 1px solid #d1d0d0;
    padding: 2px;
    white-space: normal;
}
.c1 {
  width: 10px;
  padding: 15px 0px;
}
.c2 {
  width: 185px !important;
  padding: 15px 2px;
}
.c3 {
  width: 10px;
  padding: 15px 0px;
}
.c4 {
  width: 10px;
}
.c5 {
  width: 10px;
}
.c6 {
  width: 10px;
}
.c7 {
  width: 10px;
  padding: 15px 0px;
}
.c8 {
  width: 10px;
}

#tableResults tr:nth-child(even) {background: #FFF}
#tableResults tr:nth-child(odd) {background: #FFF}
/* .table {
  width: 94%;
}
.table tr {
  line-height: 8px;
}
.table tr td{
  line-height: 12px;
}

.table thead th {
font-size: 12px;
line-height: 12px;
} */

.col-sm {
  text-align: center;
  padding: 0px;
}
.col-sm h5 {
  text-align: center;
}
.md-avatar[data-v-1b4e33f8] {
    width: 0px;
    min-width: 20px;
    height: 28px;
    border-radius: 0px;
    margin-left: 34px;
    margin-right: 10px;
}
.tooltipShort  {
  padding:10px;
  width:300px;
  height:110px;
  font-size: 14px;
}

.content-cena {
  position: absolute;
  right: 105px;
  width: 180px;
  background: rgb(102, 102, 102) none repeat scroll 0% 0%;
  top: 20px;
  font-size: 18px;
  font-weight: bold;
  color: white;
}
.content-element-lista {
  height: 40px;
  width: 740px;
  float: left;
  margin-left: 15px;
  font-size: 16px;
  font-weight: bold;
  background: #ccc;
  padding: 0px;
}
.content-element-lista span {
  padding: 0px 10px;
  line-height: 38px;
}

section.content-wrapper {
  padding:10px
}

#daneTabele {
  position: relative;
  /* margin-left: 32px;
margin-top: 20px; */
}

hr.new {
  border: 2px solid #1F5D89;
  border-radius: 5px;
  width: 300px;
  margin: 0px auto;
}
.btn-primary {
    color: #fff;
    background-color: rgb(59, 163, 255);
    border-color:rgb(59, 163, 255);
}
.dialogZestawienie {
min-height: 892px;
max-height: 892px;
}
#zestawienie div.md-dialog-container {
  width:820px !important;
  max-width: 820px !important;
  max-width: 820px !important;

}
  .md-avatar[data-v-1b4e33f8] {
      width: 0px;
      min-width: 20px;
      height: 28px;
      border-radius: 0px;
      margin-left: 34px;
      margin-right: 10px;
  }
  .tooltipShort  {
    padding:10px;
    width:300px;
    height:110px;
    font-size: 14px;
  }
  .md-dialog-title {
padding: 0px 0px 0;
color: #1F5D89;
font-weight: bold;
margin: auto;
width: 100%;
display: block;
text-align: center;
  }
#logo_pulsar img {
position: absolute;
height: 50px;
left: 0px;
width: auto;
}
#logo_pulsar {
padding: 0px;
}
#logo {
background-size: 140px;
width: 140px;
background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Podsumowanie.vue